module.exports = __webpack_public_path__ + "img/logo_final.44e12bb7.png";